import { Box, Paper, TextField } from "@mui/material";
import { PaperStyles } from "../../styles/commonStyles";
import SubmitButton from "../buttons/submitButton.component";
import { useIsMobile } from "../../hook/useIsMobile";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  deleteIrrigationTypeStart,
  resetCreateIrrigationTypeState,
  resetUpdateIrrigationTypeState,
} from "../../store/features/irrigationType/irrigationTypeSlice";
import FormActionButton from "../buttons/formActionButton.component";
import { Delete } from "@mui/icons-material";
import CustomDialog from "../muiDialogs/dialog.component";
import SuccessDialog from "../muiDialogs/successDialog.component";
import { dialogMessages } from "./utils";

const IrrigationTypeForm = ({
  defaultValues = {},
  onSubmit,
  isLoading,
  mode = "create",
  error,
  success,
  accessToken,
  irrigationType,
}) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState(null);
  const [isAction, setIsAction] = useState(false);

  const isUpdateMode = mode === "update";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogConfirm = () => {
    if (dialogMode) {
      dispatch(
        deleteIrrigationTypeStart({
          irrigationTypeId: irrigationType.id,
          accessToken,
        })
      );
      setDialogOpen(false);
    }
  };

  const handleSuccessDialogConfirm = () => {
    dispatch(resetCreateIrrigationTypeState());
    dispatch(resetUpdateIrrigationTypeState());
    setDialogOpen(false);
    navigate("/admin/irrigationType");
  };

  useEffect(() => {
    if (success && !dialogOpen) {
      setDialogOpen(true);
    }
  }, [success, dialogOpen]);

  useEffect(() => {
    if (success && dialogMode === "delete") {
      dispatch(resetCreateIrrigationTypeState());
      dispatch(resetUpdateIrrigationTypeState());
      navigate("/admin/irrigationType");
    }
  }, [success, dialogMode, navigate, dispatch]);

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper sx={PaperStyles(isMobile)} elevation={0}>
          {isUpdateMode && (
            <Box width="100%" display="flex" justifyContent="end" mb={2}>
              <FormActionButton
                startIcon={<Delete />}
                color="error"
                label="Elimina"
                onClick={() => {
                  setDialogMode("delete");
                  setIsAction(true);
                  setDialogOpen(true);
                }}
              />
            </Box>
          )}
          <Box
            display="flex"
            alignItems="center"
            gap="16px"
            justifyContent="center"
            flexDirection={isMobile ? "column" : "row"}
          >
            <TextField
              variant="filled"
              id="irrigation-name"
              label="Nome tipologia"
              fullWidth
              sx={{ "& .MuiFilledInput-root": { height: "50px" } }}
              {...register("name", { required: "Campo obbligatorio" })}
              error={!!errors.name || !!error}
              helperText={errors.name?.message}
              disabled={isLoading}
            />
          </Box>
        </Paper>
        <SubmitButton
          label={isUpdateMode ? "Aggiorna Irrigazione" : "Salva Irrigazione"}
          type="submit"
          disabled={isLoading}
        />
      </form>
      {dialogMode ? (
        <CustomDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleDialogConfirm}
          title={dialogMessages.irrigationType[dialogMode || mode].title}
          description={
            dialogMessages.irrigationType[dialogMode || mode].description
          }
          actions={isAction}
        />
      ) : (
        <SuccessDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleSuccessDialogConfirm}
          title={dialogMessages.irrigationType[dialogMode || mode].title}
          description={
            dialogMessages.irrigationType[dialogMode || mode].description
          }
        />
      )}
    </Box>
  );
};

export default IrrigationTypeForm;
